import { useAuth0 } from "@auth0/auth0-react";
import Avatar from "@material-ui/core/Avatar";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import Grid from '@mui/material/Grid';
import { ReactComponent as NextArrow } from 'assets/icons/NextArrow.svg';
import { ReactComponent as NoteIcon } from 'assets/icons/NoteIcon.svg';
import { InputField } from 'components/InputField/InputField';
import { MultiSelect } from 'components/MultiSelect/MultiSelect';
import { useSearch } from "hook";
import FinanceService from "Lib/API/Finance";
import React, { useEffect, useState } from 'react';
import { toastr } from "react-redux-toastr";
import { Card } from './Card';
import {
    AccountId,
    AccountName,
    CardContent,
    Desc,
    DescriptionWrapper,
    ExplainActions,
    MemberWrapper,
    MergeInput,
    Note,
    Title
} from './Theme';

export const MergeAccountsDetails = ({ account, formik, value, setValue }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [accounts, setAccounts] = useState([])
    const [accountlLoading, setAccountlLoading,] = useState(false);
    const [search, setSearch] = useState({ value: '', type: '' });
    const { searchAction } = useSearch({ action: setSearch });
    const actions = [
        `All the transactions on account ${formik.values?.account?.accounts?.family_name} will be transferred to account ${account?.family_name}`,
        `All the contacts on account ${formik.values?.account?.accounts?.family_name} will be transferred to account ${account?.family_name}`,
        `All the yahrzeits on account ${formik.values?.account?.accounts?.family_name} will be transferred to account ${account?.family_name}`,
        `All fields on account ${formik.values?.account?.accounts?.family_name} that empty on account ${account?.family_name} will be updated on account ${account?.family_name}`
    ]
    const isAccountExist = Object.keys(formik.values?.account)?.length !== 0
    function AccountFamilyMembers({ data }) {
        return (
            <div className="avatar-container">
                <AvatarGroup max={4}>
                    {data?.family_members?.length &&
                        data?.family_members.map((family_member, index) => {
                            return (
                                <Avatar
                                    key={index}
                                    alt={family_member?.first_name}
                                    src={family_member?.profile_img}
                                >
                                    {(
                                        family_member.first_name?.[0] + family_member.last_name?.[0]
                                    )?.toString()?.toUpperCase()}
                                </Avatar>
                            );
                        })}
                </AvatarGroup>
            </div>
        );
    }

    // Account Api
    const getAccountName = async () => {
        const token = await getAccessTokenSilently();
        setAccountlLoading(true)
        await FinanceService.getACcountNamesForMerge(token, search?.value)
            .then((res) => {
                if (res?.accounts) {
                    const newArray = res.accounts.map((item) => ({
                        title: `${item.family_name} (${item.payment?.account_type})`,
                        id: item.account_id,
                        ...item
                    }));
                    setAccounts(newArray);
                }
                setAccountlLoading(false)
            })
            .catch((err) => {
                toastr.error("Error", err?.data?.message);
                setAccountlLoading(false)
                setAccounts([]);
            });
    }

    const handleFormikChange = (items, formikField) => {
        formik.setFieldValue(formikField, items);
    }
    const handleInputMergeField = (text) => {
        setValue(text)
        if (text) {
            if (!text.includes('Merge')) {
                formik.setFieldValue('error', true);
            } else {
                formik.setFieldValue('error', false);
            }
        } else {
            formik.setFieldValue('error', false);
        }
    }
    useEffect(() => { getAccountName() }, [search])

    return (
        <Grid container spacing={4} sx={{
            marginTop: '10px',
        }}>
            <Grid item xs={12}>
                <Grid container justifyContent="center" spacing={2}>
                    <Grid item sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <Card style={{ width: '368px', height: '255.41px' }}>
                            <CardContent>
                                <MemberWrapper>
                                    {(isAccountExist && formik.values?.account?.accounts?.payment?.account_type) &&
                                        <Title className="text-capitalize">
                                            {formik.values?.account?.accounts?.payment?.account_type}
                                        </Title>}
                                </MemberWrapper>

                                <div style={{ width: '100%', marginBottom: '24px' }}>
                                    <MultiSelect placeholder='Select' label={'Account Name'} isOptinal={false} isCheckBoxOption={false} options={accounts} loading={accountlLoading}
                                        formikField={`account[accounts]`}
                                        setOptions={setAccounts}
                                        variableForSave={'title'}
                                        formik={formik}
                                        handleFormikChange={handleFormikChange}
                                        isAccount={true}
                                        formikKey={'accounts'}
                                        searchAction={searchAction}
                                        isMultiple={false}
                                    />
                                </div>
                                {isAccountExist && <AccountId>
                                    {formik.values?.account?.accounts?.account_id ? "#" + formik.values?.account?.accounts?.account_id : <br />}
                                </AccountId>}

                                {isAccountExist && <AccountFamilyMembers data={formik.values?.account?.accounts} />}

                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <NextArrow />
                    </Grid>
                    <Grid item>
                        <Card style={{ width: '368px', height: '255.41px' }} >
                            <CardContent>
                                <MemberWrapper>
                                    {account?.payment?.account_type && (
                                        <Title className="text-capitalize">
                                            {account?.payment?.account_type}
                                        </Title>
                                    )}
                                </MemberWrapper>
                                <AccountName>{account?.family_name}</AccountName>
                                <AccountId>
                                    {account?.account_id ? "#" + account?.account_id : <br />}
                                </AccountId>
                                <AccountFamilyMembers data={account} />
                            </CardContent>
                        </Card>
                    </Grid>

                </Grid >
                <DescriptionWrapper>
                    <Desc><span>{formik.values?.account?.accounts?.family_name}</span> will be merged into {account?.family_name}</Desc>
                </DescriptionWrapper>
                {isAccountExist &&
                    <ExplainActions>
                        <div>
                            {actions?.map((item, index) => (
                                <span style={{ paddingLeft: index === 0 ? "2px" : '0' }}>{index + 1}. {item}<br /></span>
                            ))}

                        </div>
                        <Note><NoteIcon /><span>This action can not be undone</span></Note>
                    </ExplainActions>}
                {isAccountExist &&
                    <MergeInput>
                        <InputField label={<div style={{ fontWeight: 'normal' }}>Type<span style={{ fontWeight: 'bolder' }}> Merge</span> to confirm</div>} isOptional={false} type="text" formik={formik}
                            message={'Please enter (Merge) to confirm'}
                            value={value} onChange={(e) => handleInputMergeField(e?.target?.value)}
                            maxLength="5"
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                }
                            }}
                            error={formik.values?.error}
                            flexDirection="column"
                        />
                    </MergeInput>}
            </Grid>

        </Grid >
    );
};
